import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { useTopicDescription } from '../../../hooks';
import { Spinner } from '../../BaseUI';
import { TopicProps } from './index';

const OPEN_AI_INACCURACY_REPORT_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSe4Q_05NKBywoWXJ2BMwylz6jqLB7s7deoLQlCOrtPbB0IdvQ/viewform';
const OPEN_AI_INACCURACY_COPY = `<strong> AI generated - <a href="${OPEN_AI_INACCURACY_REPORT_LINK}"><u>report inaccuracies</u>.</strong>`;

const Description = ({ entityId, topicName, withGrid }: TopicProps) => {
  const { topicDescription, isLoadingTopicDescription } = useTopicDescription({
    entity_id: entityId,
  });

  return (
    <>
      {isLoadingTopicDescription ? (
        <Spinner />
      ) : (
        <div className={clsx({ ['row']: withGrid })}>
          <div className={clsx({ ['col-xs-12']: withGrid })}>
            <div id="entity-custom-blurb">
              {topicDescription?.blurb ? (
                <>
                  {ReactHtmlParser(topicDescription.blurb)}
                  {topicDescription?.is_ai ? ReactHtmlParser(OPEN_AI_INACCURACY_COPY) : ''}
                </>
              ) : (
                <>
                  The Information&apos;s in-depth reporting about <strong>{topicName}</strong>.
                  <br></br>
                  Follow this topic to get the latest updates from The Information reporters and
                  subscribers.
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Description;
